export default __webpack_public_path__ + "static/media/phylogeny2.c5355f71.png";